import { IGameDataVM } from "@/shared/model/360/game-data-VM.model";
import { IGameData } from "@/shared/model/360/game-data.model";
import { IDataWrapper } from "@/shared/model/global/data-wrapper.model";
import { ISurvey } from "@/shared/model/global/survey.model";
import axios from "axios";

const baseApiUrl = "api/360-game";

export default class Game360Service {
  public sendSurveyFacettes(surveyAnswers: { analysis: any; personality: any; utility: any; commentary: any }): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/send-survey-facettes`, surveyAnswers)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public findEncrypted(id: any): Promise<IGameData> {
    return new Promise<IGameData>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/find-encrypted`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public update(entity: IDataWrapper): Promise<IGameDataVM> {
    return new Promise<IGameDataVM>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public compute(entity: IDataWrapper): Promise<IGameDataVM> {
    return new Promise<IGameDataVM>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/compute`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public computeSpecificScores(gameId: number, scores: Array<string>): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/compute-specific-scores/${gameId}`, scores)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getResults(id: any): Promise<IGameDataVM> {
    return new Promise<IGameDataVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/get-results`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public sendResults(post: any): Promise<IGameDataVM> {
    return new Promise<IGameDataVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/send-results`, post)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public createPublicData(initGameData): Promise<IGameDataVM> {
    return new Promise<IGameDataVM>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/create-public-data`, initGameData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public saveClient(id): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/save-client`, id)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateSurvey(survey: ISurvey) {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-survey`, survey)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public link360toEsg(gameId: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/link-360-to-esg/${gameId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public sendEsgInterest(gameData: IDataWrapper): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/send-esg-interest`, gameData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getEsgLinkFromGameData(encryptedGameId: any): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-esg-link-from-game-data/${encryptedGameId}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
